export { default } from 'shared/components/floatLayer'
